import React from 'react'

export const AgreementConsent = ({ signin }) => {
  return (
    <div className='text-sm text-gray-700'>
      By {signin ? "signing in" : "signing up"} you agree to our{" "}
      <a
        href="https://blendcarerx.com/tos"
        target="_blank"
        className="text-primary hover:underline text-sm"
      >
        Terms of Uses
      </a>
      ,{" "}
      <a
        href="https://blendcarerx.com/privacy-policy"
        target="_blank"
        className="text-primary hover:underline text-sm"
      >
        Privacy Policy
      </a>
      ,{" "}
      <a
        href="https://blendcarerx.com/hipaa-policy"
        target="_blank"
        className="text-primary hover:underline text-sm"
      >
        HIPAA Policy
      </a>
      ,{" "}
      <a
        href="https://blendcarerx.com/delivery-policy"
        target="_blank"
        className="text-primary hover:underline text-sm"
      >
        Delivery Policy
      </a>
      , and{" "}
      <a
        href="https://blendcarerx.com/hipaa-marketing-authorization"
        target="_blank"
        className="text-primary hover:underline text-sm"
      >
        HIPAA marketing authorization
      </a>
    </div>
  );
}
